import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
//
import { Card } from "react-bootstrap";
//
import { getCategories, getEvents } from "../../redux/features/coins/actions";
//
import BoxLoading from "../general/BoxLoading.jsx";
import DesktopEventsList from "./coin-events/DesktopEventsList";
import MobileEventsList from "./coin-events/MobileEventsList";
import NothingToShow from "../general/NothingToShow";
import FilterDropdown from "../general/FilterDropdown";

function CoinEvents({ coins, windowSize }) {
  const [loading, setLoading] = useState(false);
  //
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});

  /**
   * Get Categories
   */
   const get_categories = async () => {
    // start loading
    setLoading(true);

    // request
    await getCategories().then((res) => {
      if (res) {
        setCategories(res.event);
        setSelectedCategory(res.event[0]);
      }
    });

    // stop loading
    setLoading(false);
  };

  /**
   * Get Coin Evants
   * if active filter is selected
   */
  const get_coin_events = async () => {
    if (selectedCategory.value) {
      // start loading
      setLoading(true);

      // set variable
      let category = selectedCategory.value;

      // request
      await getEvents(category).then((res) => {
        if (res) {
          setEvents(res);
        }
      });

      setLoading(false);
    }
  };

  useEffect(() => {
    get_categories();

    // eslint-disable-next-line
  }, []);

  /**
   * Get coin events every time active filter change
   */
  useEffect(() => {
    get_coin_events();

  }, [selectedCategory]);

  return (
    <Card className="coin-events">
      <Card.Header className="with-dropdown">
        Upcoming Events
        <FilterDropdown
          filters={categories}
          activeFilter={selectedCategory}
          action={(item) => setSelectedCategory(item)}
        />
      </Card.Header>

      <Card.Body className={windowSize > 576 ? "table-padding" : "p-0"}>
        {events.length ? (
          <>
            {windowSize > 576 ? (
              <DesktopEventsList items={events} />
            ) : (
              <MobileEventsList items={events} />
            )}
          </>
        ) : (
          <NothingToShow text={loading ? "Loading..." : "Nothing to show"} />
        )}
      </Card.Body>

      {loading && <BoxLoading />}
    </Card>
  );
}

CoinEvents.propTypes = {
  coins: PropTypes.array.isRequired,
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  coins: state.coinsReducer.coins,
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(CoinEvents);
